import { Component, Inject, OnInit } from '@angular/core';
import { CellPhoneUpdateDialog } from '../../../../profile/models/cellphone-update-dialog.model';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { UntypedFormGroup, UntypedFormBuilder, Validators } from '@angular/forms';
import { SnackBarService } from 'app/shared-services/services/snack-bar.service';
import { UserService } from 'app/shared-services/services/user.service';
import { CellPhoneValidatorRegex } from 'app/shared-components/const/regex/validators.regex';
import { CellPhoneUpdateRequest } from 'app/profile/models/cellphone-update-request.model';
import { takeUntil } from 'rxjs/operators';
import { CellPhoneUpdateResponse } from 'app/profile/models/cellphone-update-response.model';
import { Observable } from 'rxjs';
import { UnsubscribeComponent } from 'app/shared-components/components/unsubscribe/unsubscribe.abstract';

@Component({
    selector: 'app-cellphone-update-dialog',
    templateUrl: './cellphone-update-dialog.component.html',
    styleUrls: ['./cellphone-update-dialog.component.scss'],
    standalone: false
})
export class CellPhoneUpdateDialogComponent extends UnsubscribeComponent implements OnInit {

    public form: UntypedFormGroup;

    public save$: Observable<CellPhoneUpdateResponse>;

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: CellPhoneUpdateDialog,
        private dialog: MatDialogRef<CellPhoneUpdateDialogComponent>,
        private formBuilder: UntypedFormBuilder,
        private userService: UserService,
        private snackBarService: SnackBarService
    ) {
        super();
    }

    ngOnInit(): void {
        this.form = this.formBuilder.group({
            cellPhoneControl: ['', [Validators.required, Validators.pattern(CellPhoneValidatorRegex)]]
        });
    }

    public save(): void {
        if (this.form.valid) {
            const request = new CellPhoneUpdateRequest({
                cellPhoneNumber: this.form.get('cellPhoneControl').value
            });

            this.save$ = this.userService.updateCellPhoneNumberB2c(request);

            this.save$
                .pipe(takeUntil(this.unsubscriber))
                .subscribe((response) => {

                    if (response && response.updated) {
                        this.phoneUpdated(true);
                        this.snackBarService.openSuccessSnackbar('Your cell phone number has been updated');
                    } else {
                        const message = response.message ? response.message : 'Unable to update your cell phone number at this moment';
                        this.snackBarService.openErrorSnackbar(message);
                    }

                }, () => this.snackBarService.openErrorSnackbar('Unable to update your cell phone number at this moment'));
        } else {
            this.form.markAllAsTouched();
        }
    }

    public cellphoneRequired(): boolean {
        return this.form
            .get('cellPhoneControl')
            .hasError('required');
    }

    public validCellphoneRequired(): boolean {
        return this.form
            .get('cellPhoneControl')
            .hasError('pattern')
            && this.form
                .get('cellPhoneControl')
                .touched;
    }

    public close(): void {
        this.dialog.close(false);
    }

    public phoneUpdated(updated: boolean): void {
        this.dialog.close(updated);
    }
}
